import { Bar } from 'vue-chartjs'
import ChartPlugin from '@/components/charts/add-plugin'
import { mixins } from 'vue-class-component';
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';



@Component
export default class BarChart extends mixins(Bar, Vue) {
  @Prop({ type: Object })
  chartData: Object;
  @Prop({ type: Object })
  options: Object;
  plugin: ChartPlugin = new ChartPlugin();

  mounted() {
    this.addPlugin(this.plugin.barPluginConfig);
    this.renderChart(_.cloneDeep(this.chartData), this.options || this.plugin.DEFAULT_OPTION);
  }
  @Watch('chartData')
  @Watch('options')
  updateChart() {
    this.renderChart(_.cloneDeep(this.chartData), this.options || this.plugin.DEFAULT_OPTION);
  }
}